import React from "react";

import MathBlock from "./MathBlock";
import FractionBlock from "./FractionBlock";
import ChemistryBlock from "./ChemistryBlock";
import GeometryBlock from "./GeometryBlock";
import GraphBlock from "./GraphBlock";
import TableBlock from "./TableBlock";
import ImageBlock from "./ImageBlock";
import ListBlock from "./ListBlock";

const StructuredContentRenderer = ({
    payload,
    mode = "preview",
}) => {
    if (!payload) return null;

    const blocks = Array.isArray(payload)
        ? payload
        : payload.blocks || [];

    if (!blocks.length) return null;

    return (
        <div
            className={`structured-content structured-content-${mode}`}
            style={{
                width: "100%",
            }}
        >
            {blocks.map((block, index) => {
                if (!block || !block.type) {
                    return null;
                }

                switch (block.type) {
                    case "math":
                        return (
                            <MathBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "fraction":
                        return (
                            <FractionBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "chemistry":
                        return (
                            <ChemistryBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "shape":
                    case "geometry":
                        return (
                            <GeometryBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "graph":
                        return (
                            <GraphBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "table":
                        return (
                            <TableBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "image":
                        return (
                            <ImageBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "list":
                        return (
                            <ListBlock
                                key={index}
                                block={block}
                                mode={mode}
                            />
                        );

                    case "text":
                        return (
                            <div
                                key={index}
                                style={{
                                    whiteSpace: "pre-wrap",
                                    marginBottom: 16,
                                }}
                            >
                                {block.content || ""}
                            </div>
                        );

                    default:
                        return null;
                }
            })}
        </div>
    );
};

export default StructuredContentRenderer;